// extracted by mini-css-extract-plugin
module.exports = {"header":"styles_header__3XSGc","container":"styles_container__4x6M0","title":"styles_title__Glsrq","wrapper":"styles_wrapper__3mPeo","answer":"styles_answer__r-hRN"};